import { useEffect, useState } from 'react';
import { Button, TextField,  Grid, Box, Typography, Alert, Stack, } from '@mui/material';
import {  formatDate, formatDate1, formToJson} from '../../../Utils/Common';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { MemberAutoComplete } from '../../fragement/MemberAutoComplete';
import { MyTextField } from '../../../Component/MuiEx';

import { MemberCourseSelect } from '../../member/fragement/MemberCourseSelector';

const EditClassMember = (props) => {
    const {data,onSubmit,onClose,classobj} = props
    const [fieldErrors, setFieldErrors] = useState()    
    const [member,setMember] = useState()
    const [course,setCourse] = useState()
    const [joinDate,setJoinDate] = useState(data && data.join_date?data.join_date:formatDate(new Date()))
    const [error, setError] = useState()
    const [fields,setFields] = useState({})
    // const session = getUserSession(apis)    
    const handleSubmit = (event) => {
        setFieldErrors()
        setError()
        event.preventDefault();
        
        const postData = {}
        postData.member_id = member?member.id:data.member_id
        if(!postData.member_id) {
            setError("Please choose a member")
            return
        }
        if(course) {
            postData.member_course_id = course.id
        }else {
            setError("Please choose a course")
        }
        if(joinDate) {
            postData.join_date = joinDate
        }else {
            setError("Please choose a joined date")
        }
        postData.id = data ? data.id:0
        postData.class_id = classobj?classobj.id:0        
        onSubmit && onSubmit(postData,setError,setFieldErrors)
    };
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ marginTop: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                <Typography component="h1" variant="h5">Add & Edit Course</Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }} autoComplete="off">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <MemberAutoComplete defaultValue={data?.member_id} onChange={(name,value)=>{setMember(value)}}/>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            {(member || data?.member_id > 0) && <MemberCourseSelect defaultValue={data?.member_course_id} member_id={member?.id || data?.member_id}
                                onChange={(n,v)=>setCourse(v)} />}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField type="date" required label="Join date" name="join_date" id="join_date" onChange={(e)=>{setJoinDate(e.target.value)}} fullWidth defaultValue={joinDate} 
                                error={fieldErrors && fieldErrors.join_date ? true : false}
                                helperText={fieldErrors && fieldErrors.join_date ? fieldErrors.join_date : ''}/>
                        </Grid>
                    </Grid>
                    {error && <Alert severity="error">{error}</Alert>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }} > Submit </Button>
                    <Button type="button" fullWidth variant="outlined" sx={{ mt: 1, mb: 2 }} onClick={() => { onClose && onClose(false) }}> Cancel </Button>
                    
                </Box>
            </Box>
        </Container>
    );
}
export default EditClassMember